module.exports = __webpack_public_path__ + "static/media/abbateuse.cd514484.png";